import { produce } from "immer";

import {
  ShippingsGroupsActionsTypes,
  ShippingsGroupsReducerActions,
  ShippingsGroupsState
} from "../types/ShippingsGroups.reducer.types";

const INITIAL_STATE: ShippingsGroupsState = {
  list: [],
  isLoadingList: false,
  message: undefined
};

export default function reducer(
  state = INITIAL_STATE,
  action: ShippingsGroupsReducerActions
): ShippingsGroupsState {
  return produce(state, draft => {
    switch (action.type) {
      case ShippingsGroupsActionsTypes.CREATE_REQUEST: {
        draft.message = undefined;
        break;
      }

      case ShippingsGroupsActionsTypes.CREATE_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsGroupsActionsTypes.CREATE_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsGroupsActionsTypes.DISMISS_MESSAGE: {
        draft.message = undefined;
        break;
      }

      case ShippingsGroupsActionsTypes.EDIT_REQUEST: {
        draft.message = undefined;
        break;
      }

      case ShippingsGroupsActionsTypes.EDIT_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsGroupsActionsTypes.EDIT_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case ShippingsGroupsActionsTypes.LIST_REQUEST: {
        draft.isLoadingList = true;
        draft.list = [];
        break;
      }

      case ShippingsGroupsActionsTypes.LIST_FAIL: {
        draft.isLoadingList = false;
        draft.list = [];
        break;
      }

      case ShippingsGroupsActionsTypes.LIST_SUCCESS: {
        draft.isLoadingList = false;
        draft.list = action.payload.list;
        break;
      }
      default:
    }
  });
}
